export default __webpack_public_path__ + "static/hr-4e385c019407c702c64c0e853088daeb.jpg";